import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Cancelar pedido',
  title: '¡No canceles a la ligera!',
  text: 'Si hay un problema menor con el pedido, llama al cliente y resuélvelo.',
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Artículos sin stock',
    [OrderRejectionReason.ClosingSoon]: 'Tienda cerrada',
    [OrderRejectionReason.StoryBusy]: 'Tienda demasiado ocupada',
    [OrderRejectionReason.CustomerMistake]: 'Cliente llamó para cancelar',
    [OrderRejectionReason.DriverNotArrived]: 'Conductor no llegó',
  },
  buttons: {
    confirm: 'Confirmar',
  },
};
